import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=083dfd54&"
import script from "./FormCreate.vue?vue&type=script&lang=ts&"
export * from "./FormCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports